module.exports = __webpack_public_path__ + "img/hondaodyssey.eeb4fd9d.png";